import { render, staticRenderFns } from "./FHIRSettingsManagement.vue?vue&type=template&id=48edd547&scoped=true&"
import script from "./FHIRSettingsManagement.vue?vue&type=script&lang=ts&"
export * from "./FHIRSettingsManagement.vue?vue&type=script&lang=ts&"
import style0 from "./FHIRSettingsManagement.vue?vue&type=style&index=0&id=48edd547&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48edd547",
  null
  
)

export default component.exports